<div class="mobile-menu-container">
  <button class="btn-close" (click)="closeMenu()"></button>
  <ul class="links-container">
    @for (item of parsedMenu(); track item.key) {
      <li>
        @if (item.isVisible) {
          @if (item.key === 'list' && headerData().list_external) {
            <a
              class="nav-link"
              [href]="[headerData().list_url]"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeMenu()"
              target="_blank"
              rel="noopener">
              {{ item.title }}
            </a>
          } @else if (showProposals() && item.key === 'proposals') {
            <a class="nav-link" href="https://booking.valair.it/IT/holidays/search?" target="_blank" rel="noopener">
              Viaggi Gattinoni
            </a>
          } @else {
            <a
              class="nav-link"
              [routerLink]="[item.link]"
              routerLinkActive="active"
              [routerLinkActiveOptions]="{ exact: true }"
              (click)="closeMenu()">
              {{ item.title }}
            </a>
          }
        }
      </li>
    }
    @if (headerData().pages.length) {
      <li class="nav-item nav-primary">
        <a
          type="button"
          class="nav-link text-center"
          (click)="collapse.toggle()"
          [attr.aria-expanded]="!isCollapsed"
          aria-controls="collapseExample">
          Pagine
        </a>
        <ul #collapse="ngbCollapse" [(ngbCollapse)]="isCollapsed" class="nav flex-column">
          @for (page of headerData().pages; track page.slug) {
            <li class="nav-item">
              <a (click)="closeMenu()" [title]="page.title" [routerLink]="['/pagine', page.slug]" class="nav-link">
                <span>{{ page.title }}</span>
              </a>
            </li>
          }
        </ul>
      </li>
    }
  </ul>
  <div class="bottom-buttons">
    @if (headerData().signed_agency?.signed_agency) {
      <div class="signed-agency-container">
        <a class="btn btn-primary" [href]="headerData().signed_agency.link_url" (click)="closeMenu()">
          {{ headerData().signed_agency.link_label }}
        </a>
      </div>
    }
    <div class="action-buttons">
      <button class="btn btn-primary" routerLink="/newsletter" (click)="closeMenu()">Iscrivitti alla newsletter</button>
    @if (auth.state.user) {
      @if (!auth.isClient) {
        <a class="btn btn-primary" routerLink="/back" routerLinkActive="active" (click)="closeMenu()">
          <fa-icon class="ms-auto" [icon]="dashboardIcon"></fa-icon>
          <span class="visually-hidden">Panello di controllo</span>
        </a>
      }
      @if (auth.isClient) {
        <a class="btn btn-primary" routerLink="/profile" routerLinkActive="active">
          <fa-icon class="ms-auto" [icon]="userIcon"></fa-icon>
          <span class="visually-hidden">Profilo</span>
        </a>
      }
      <a class="btn btn-primary" (click)="auth.logout(); closeMenu()">
        <fa-icon class="ms-auto" [icon]="logoutIcon"></fa-icon>
        <span class="visually-hidden">Logout</span>
      </a>
    } @else {
      <a
        class="btn btn-primary"
        routerLink="/auth/login"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        queryParamsHandling="merge"
        (click)="closeMenu()">
        <fa-icon class="ms-auto" [icon]="loginIcon"></fa-icon>
        <span class="visually-hidden">Login</span>
      </a>
      <a
        class="btn btn-primary"
        routerLink="/auth/registrazione"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        queryParamsHandling="merge"
        (click)="closeMenu()">
        <fa-icon class="ms-auto" [icon]="signUpIcon"></fa-icon>
        <span class="visually-hidden">Register</span>
      </a>
    }
    </div>
  </div>
</div>
